const infoExplorerElements = {
  triggers: 'button[data-content-id]',
  contentBlocks: '.esc-landing__info-explorer__content__block[data-content-id]',
  mainImage: '.esc-landing__info-explorer__image img',
  scroller: '.esc-landing__info-explorer__content__scroller'
};

class InfoExplorer extends HTMLElement {

  constructor() {
    super();
    this.allContentBlocks = this.querySelectorAll(infoExplorerElements.contentBlocks);

    this.allTriggers = this.querySelectorAll(infoExplorerElements.triggers);

    this.mainImage = this.querySelector(infoExplorerElements.mainImage);

    this.contentHeader = this.querySelector('.esc-landing__info-explorer__content__header__area');

    this.scoller = this.querySelector(infoExplorerElements.scroller);

    this.currentContentBlock = this.allContentBlocks[0];

    this.currentTrigger = this.allTriggers[0];

    this.allTriggers.forEach((trigger) => {
      trigger.addEventListener(
        'click',
        this.triggerClick.bind(this)
      );
    });

    window.addEventListener('resize', this.resizeScroller.bind(this));

    this.resizeScroller();
    setInterval(resizeScroller, 250);
  }

  resizeScroller() {
    const newHeight = this.mainImage.clientHeight - this.contentHeader.clientHeight;
    this.scoller.style.height = `${newHeight}px`;
  }

  triggerClick(event) {
    event.preventDefault();
    
    this.currentContentBlock.classList.remove('content-block--active');

    this.currentTrigger.classList.remove('active-content--trigger')

    const contentId = event.currentTarget.dataset.contentId;

    this.currentContentBlock = Array.from(this.allContentBlocks).find((contentBlock) => contentBlock.dataset.contentId === contentId);

    this.currentTrigger = Array.from(this.allTriggers).find((contentBlock) => contentBlock.dataset.contentId === contentId);

    this.currentContentBlock.classList.add('content-block--active');

    this.currentTrigger.classList.add('active-content--trigger');

    this.mainImage.removeAttribute('srcset');
    this.mainImage.setAttribute('src', this.currentTrigger.dataset.image);
  }
}

customElements.define('info-explorer', InfoExplorer);